/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type appOkta_viewer = {
    readonly id: string;
    readonly company: {
        readonly id: string;
        readonly oktaEnabled: boolean | null;
        readonly AADEnabled: boolean | null;
        readonly oneloginEnabled: boolean | null;
        readonly scimUsernamePassword: string | null;
        readonly oktaClientId: string | null;
        readonly oktaClientSecret: string | null;
        readonly oktaUrl: string | null;
        readonly oktaDomainSuffix: string | null;
    } | null;
    readonly " $refType": "appOkta_viewer";
};
export type appOkta_viewer$data = appOkta_viewer;
export type appOkta_viewer$key = {
    readonly " $data"?: appOkta_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"appOkta_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appOkta_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scimUsernamePassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaClientSecret",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaDomainSuffix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '22ef10eee201e459fd5bc8f167bc1256';
export default node;
